import { Injectable, PLATFORM_ID, Renderer2, RendererFactory2, inject } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';

import { ConfigService, CookieService } from '@fcom/core';

import { FINNAIR_THEME, FINNAIR_THEME_COOKIE_NAME, FinnairTheme } from '../../interfaces/theme.interface';

@Injectable({ providedIn: 'root' })
export class FinnairThemeService {
  private cookieService = inject(CookieService);
  private platform = inject(PLATFORM_ID);
  private serverTheme = inject<FinnairTheme>(FINNAIR_THEME, { optional: true });
  private renderer2: Renderer2 = inject(RendererFactory2).createRenderer(null, null);
  private document = inject<Document>(DOCUMENT);
  private configService = inject(ConfigService);

  getTheme(): FinnairTheme {
    if (!this.configService.cfg.allowNewBrandTheming) {
      return FinnairTheme.LEGACY;
    }

    if (isPlatformBrowser(this.platform)) {
      const cookie = this.cookieService.getItem(FINNAIR_THEME_COOKIE_NAME);
      const isValidTheme = (Object.values(FinnairTheme) as string[]).includes(cookie);

      return isValidTheme ? (cookie as FinnairTheme) : FinnairTheme.LEGACY;
    }

    return this.serverTheme ?? FinnairTheme.LEGACY;
  }

  setTheme(theme: FinnairTheme): void {
    this.cookieService.setItem(FINNAIR_THEME_COOKIE_NAME, theme);
  }

  applyThemeClass(): void {
    const theme = this.getTheme();
    const el = this.document.documentElement;

    if (el) {
      this.getHtmlElementClassNames(theme).forEach((className) => {
        this.renderer2.addClass(el, className);
      });
    }
  }

  getHtmlElementClassNames(theme: FinnairTheme): string[] {
    if (theme === FinnairTheme.LIGHT_THEME) {
      return ['finnair-pro-fonts', 'light-theme'];
    }

    if (theme === FinnairTheme.DARK_THEME) {
      return ['finnair-pro-fonts', 'dark-theme'];
    }

    return ['finnair-fonts', 'legacy-theme'];
  }
}
